module.exports = __webpack_public_path__ + "img/tel_broadcast_example.65221b07.png";